<template>
  <div>
    <div :class="$style.titleContainer">
      <div :class="$style.title">{{ label }}</div>
      <icon
          v-if="showInfo"
          @click.native="infoClicked"
          icon="info-filled"
          :class="$style.info"
      ></icon>
      <span v-if="optional" :class="$style.optional">{{optionalLabel}}</span>
    </div>
    <p :class="$style.description" v-if="hasSlotContent">
      <slot></slot>
    </p>
    <input
      type="text"
      :value="value"
      :class="[
        $style.input,
        $style[size],
        $style.licensePlate,
        { [$style.inputError]: isInvalid }
      ]"
      @input="onInputValueChanged($event)"
      @blur="onInputBlur($event)"
      :disabled="disabled"
      :placeholder="placeholder"
    />
    <div>
        <slot name="result"></slot>
    </div>
  </div>
</template>

<script>
import icon from "../display/icon";

export default {
  name: "license-plate-input-fragment",
  components: { icon },
  props: {
    label: { type: String, required: true },
    optional: { type: Boolean, default: false },
    optionalLabel: { type: String, default: "Optioneel" },
    showInfo: { type: Boolean, default: false },
    isInvalid: { type: Boolean, default: false },
    value: { type: String },
    placeholder: { type: String, required: false },
    disabled: { type: Boolean, default: false },
    size: {
      type: String,
      default: "medium",
      validator: function(value) {
        return ["small", "medium", "max"].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    hasSlotContent() {
      return this.$slots && this.$slots.default && this.$slots.default.length;
    }
  },
  methods: {
    infoClicked() {
      this.$emit("info-clicked");
    },
    onInputValueChanged($event) {
      this.$emit("input", $event.target.value);
    },
    onInputBlur($event) {
      this.$emit("blur", $event.target.value);
    }
  }
};
</script>

<style module lang="scss">
@import "../../style/modules/input.module";
</style>
